<template>
  <div class="pt-2">
    <v-row no-gutters>
      <v-col :md="3" cols="12">
        <div
          class="d-flex align-center field-post-media"
          style="min-width: 56px"
        >
          <icon name="icon-url-photo" width="45" height="45" class="mr-3" />
          <translate>Photo</translate>
        </div>
      </v-col>
      <v-col :md="9" cols="12">
        <v-file-input
          class="photoInputCustom"
          ref="photoInput"
          multiple
          prepend-icon=""
          outlined
          :clearable="false"
          :placeholder="photos.length ? '' : $gettext('Add Photo')"
          accept="image/*"
          hide-details="auto"
          :disabled="offAddPhoto"
          dense
          @change="onChangeFiles"
        >
          <template v-slot:selection></template>
          <template v-slot:prepend-inner>
            <template v-if="photos.length">
              {{ photos.length + " file(s)" }}
            </template>
          </template>
        </v-file-input>
        <!-- cropped for single -->
        <InputCrop
          v-if="singlePhoto"
          title="Photo Cropper"
          :aspectRatio="1"
          :file="fileUpload"
          ref="PhotoCropper"
          @cropped="onCroppedFile"
        />
      </v-col>
    </v-row>
    <v-row
      no-gutters
      v-if="photos.length > 0"
      style="position: relative; margin-top: 16px"
    >
      <v-col cols="12" class="mediaGrid mediaFileInput">
        <div
          v-for="(media, index) in photos"
          :key="index"
          :class="['block', generateMediaBlock(index)]"
        >
          <template v-if="index < 5">
            <v-img
              :src="media.thumb"
              position="center center"
              width="100%"
              height="100%"
              cover
            />
          </template>
          <template v-if="photos.length > 5 && index == 4">
            <div class="mediaGrid-extend">+ {{ photos.length - 5 }}</div>
          </template>
        </div>
      </v-col>
      <v-col>
        <div style="position: absolute; top: 10px; left: 10px" v-if="!singlePhoto">
          <v-btn @click="openEditAllDialog()" small>
            <v-icon size="14">fal fa-pencil</v-icon>
            <translate>Edit All</translate>
          </v-btn>
          <v-btn @click="addPhoto" small class="ml-2">
            <v-icon size="14">fal fa-plus</v-icon>
            <translate>Add</translate>
          </v-btn>
        </div>
        <v-btn
          @click="removeAllPhoto()"
          icon
          small
          style="
            position: absolute;
            top: 10px;
            right: 10px;
            background: #fff;
            color: #000;
          "
        >
          <v-icon size="14">fas fa-xmark</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      v-model="isOpenEditAllDialog"
      max-width="600"
      width="auto"
      persistent
    >
      <v-card class="px-md-8 px-4 py-3">
        <v-row no-gutters justify="space-between">
          <PageTitle :title="$gettext('Edit All Photos')" />
          <span
            class="rounded-circle gray6 buttonClose"
            @click="isOpenEditAllDialog = false"
          >
            <v-icon class="fal fa-xmark"></v-icon>
          </span>
        </v-row>
        <v-row
          class="pb-10"
          v-for="(photo, index) in editAllPhotos"
          no-gutters
          :key="index"
        >
          <v-col cols="12">
            <v-text-field
              v-model="photo.title"
              :placeholder="$gettext('Photo Title')"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-img
              :src="photo.thumb"
              :max-width="'100%'"
              :max-height="'200px'"
              :position="'unset'"
              :class="'mx-auto'"
            >
              <v-btn @click="removePhoto(index)" class="ma-2">
                <translate>Remove</translate>
              </v-btn>
            </v-img>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          block
          class="text-none font-weight-bold text-h6 py-6 mt-6"
          @click="save()"
        >
          <v-icon class="fas fa-floppy-disk pr-3"></v-icon>
          <translate>Save</translate>
        </v-btn>
      </v-card>
    </v-dialog>
    <canvas ref="canvas" style="position:fixed; left: 9999px"/>
  </div>
</template>
<script>
import InputCrop from "@/components/Forms/InputCrop";
import PageTitle from "@/components/PageTitle";
export default {
  name: "FileInput",
  components: {
    PageTitle,
    InputCrop,
  },
  props: {
    value: { type: Array, default: () => [] },
    maxPhoto: { type: Number, default: 40 },
    singlePhoto: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpenEditAllDialog: false,
      photos: [],
      editAllPhotos: [],
      fileUpload: null,
    };
  },
  computed: {
    offAddPhoto() {
      if (this.singlePhoto) {
        if (this.photos.length) return true;
      }
      return false;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.photos = val;
        }
      },
    },
  },
  methods: {
    reset() {
      this.photos = [];
      this.$refs.photoInput.reset();
    },
    openEditAllDialog() {
      this.editAllPhotos = Object.assign([], this.photos);
      this.isOpenEditAllDialog = true;
    },
    addPhoto() {
      try {
        this.$refs.photoInput.$refs.input.click();
      } catch (err) {}
    },
    removePhoto(index) {
      this.editAllPhotos.splice(index, 1);
    },
    save() {
      this.photos = this.editAllPhotos;
      this.$emit("input", this.photos);
      this.isOpenEditAllDialog = false;
    },
    removeAllPhoto() {
      this.photos = [];
      this.$emit("input", this.photos);
    },
    async onChangeFiles(files) {
      if (files && files.length) {
        console.log("this.maxPhoto: ", this.maxPhoto);
        if (files.length > this.maxPhoto) {
          let text = this.$gettextInterpolate(this.$gettext("Max files <= %{max}"), {
            max: this.maxPhoto + "",
          });
          this.$toast.alert(text);
          this.$refs.photoInput.reset();
          this.photos = [];
          return;
        }
        for (let i in files) {
          if (files[i].size > 1024 * 1024 * 20) {
            this.$toast.alert(this.$gettext(`File size must under 20Mb`));
            this.$refs.photoInput.reset();
            return;
          }
          const file = await this.compressFile(files[i]);

          this.photos.unshift({
            title: "",
            thumb: URL.createObjectURL(file),
            file,
          });

          // cropped for single
          if (this.singlePhoto) {
            let reader = new FileReader();
            reader.readAsDataURL(files[i]);
            reader.onload = (e) => {
              this.fileUpload = e.target.result; // change data image
              this.$refs.PhotoCropper.open(true); // show popup
            };
          }
        }
        this.$emit("input", this.photos);
      }
    },
    // cropped for single
    async onCroppedFile(file) {
      // base64 to file
      return fetch(file)
        .then((res) => res.blob())
        .then((blob) => {
          const fCrop = new File([blob], "cropped_" + new Date().getTime(), {
            type: "image/png",
          });
          // set photos
          this.photos = [
            {
              title: "",
              thumb: URL.createObjectURL(fCrop),
              file: fCrop,
            },
          ];
          this.$emit("input", this.photos);
        });
    },

    generateMediaBlock(index) {
      let maxShow = this.photos.length;
      if (maxShow > 5) maxShow = 5;
      switch (maxShow) {
        case 1:
          return "frame-12x12";
        case 2:
          switch (index) {
            case 0:
              return "frame-6x12";
            case 1:
              return "frame-6x12";
          }
        case 3:
          switch (index) {
            case 0:
              return "frame-8x8";
            case 1:
              return "frame-4x4";
            case 2:
              return "frame-4x4";
          }
        case 4:
          switch (index) {
            case 0:
              return "frame-9x9";
            case 1:
              return "frame-3x3";
            case 2:
              return "frame-3x3";
            case 3:
              return "frame-3x3";
          }
        case 5:
          switch (index) {
            case 0:
              return "frame-6x6";
            case 1:
              return "frame-6x6";
            case 2:
              return "frame-4x4";
            case 3:
              return "frame-4x4";
            case 4:
              return "frame-4x4";
          }
      }
    },

    compressFile(file) {
      console.log('start compress file', file.size)
      const image = new Image();
      const fileName = file.name;
      const canvas = this.$refs.canvas;
      const canvasContext = canvas.getContext("2d");
      canvasContext.clearRect(0, 0, canvas.width, canvas.height);
      image.src = URL.createObjectURL(file);
      return new Promise(function(resolve, reject) {
        image.onload = function() {
          console.log('image loaded, with dimension', image.width, image.height)
          const ratio = image.width / image.height
          const width = Math.min(image.width, 1920)
          const height = width / ratio;
          canvasContext.canvas.width = width;
          canvasContext.canvas.height = height;
          canvasContext.drawImage(image, 0, 0, width, height);

          // compress and set input
          canvas.toBlob(
            function(blob) {

              const compressedFile = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now()
              });
              console.log('compressedFile created', compressedFile.size)
              canvasContext.clearRect(0, 0, canvas.width, canvas.height);
              resolve(compressedFile);
            },
            "image/jpeg",
            0.95
          );
        };
      })
    }
  },
};
</script>

<style lang="scss">
.photoInputCustom .v-input__prepend-inner {
  margin-top: 12px !important;
}
</style>
